import React from 'react';

import './Vicki-page.scss';
import PdfViewer from "../../components/pdf-viewer/PdfViewer";
import vickiOverviewPdf from "../../assets/pdf/vicki-page/vicki-overview-2024.pdf";

function VickiPage(props) {
    return (
        <div className={'vicki-page-wrapper'}>
            <section className={'section'}>
                <h2 className={'section-title'}>Vicki PDF</h2>

                <div className={'vicki-pdf-wrapper'}>
                    <PdfViewer file={vickiOverviewPdf} />
                </div>
            </section>
        </div>
    );
}

export default VickiPage;
